import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-refresh-analytics-modal',
  templateUrl: './refresh-analytics-modal.component.html',
  styleUrls: ['./refresh-analytics-modal.component.scss'],
})
export class RefreshAnalyticsModalComponent implements OnInit {
  refresh = new UntypedFormControl();

  constructor(private ngbModal: NgbActiveModal) {}

  ngOnInit(): void {}

  save(): void {
    this.ngbModal.close(this.refresh.value);
  }

  cancel(): void {
    this.ngbModal.dismiss();
  }
}
